import React from 'react';
import { StyleSheet, View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { REDESIGN_COLORS } from '../../styles/colors';

/**
 * ImagePlaceholder - Dark background with a faded car icon.
 * Used as a standalone fallback and alongside expo-image placeholder prop.
 */
const ImagePlaceholder = ({ style }) => (
  <View style={[styles.container, style]}>
    <MaterialCommunityIcons name="car-side" size={64} color="rgba(255,255,255,0.15)" />
  </View>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: REDESIGN_COLORS.cardBg,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ImagePlaceholder;
